import { render } from "./customer-modal.vue?vue&type=template&id=b53d0df4"
import script from "./customer-modal.vue?vue&type=script&lang=js"
export * from "./customer-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__